// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","166":"supportinfo","390":"swiper","406":"newsinfo","443":"about","551":"support","697":"news","823":"solution"}[chunkId] + "." + {"18":"09e496bb","166":"5992f77a","390":"65ba062f","406":"c9802472","443":"19d82282","551":"d82b405a","697":"4b5abe24","823":"57a1b073"}[chunkId] + ".css";
};